import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import { debugLogPages } from '../../app/helpers/debugHelper';
import { startLoadingHomeContentItems } from '../../app/actions/homeContentActions';
import { HOME_CONTENT_TYPE_KEYS, pickHomeItems } from '../../app/helpers/homeContentHelper';

const EndUserCardCarouselSlider = () => {
  debugLogPages(":: EndUserCardCarouselSlider");
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { dashboardCarouselModulesEnabled } = useSelector((state) => state.configuration);
  const { items } = useSelector((state) => state.homeContent);

  useEffect(() => {
    dispatch(startLoadingHomeContentItems());
  }, [dispatch]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  };

  const cards = pickHomeItems(items, HOME_CONTENT_TYPE_KEYS.MODULE_CARDS, i18n.language).map((row) => ({
    id: row.id,
    title: row.title,
    text: row.text,
    img: row.image_url,
  }));

  return (
    <div className='w-full max-w-6xl m-auto slider-cards-carousel px-4'>
      {dashboardCarouselModulesEnabled === "true" && cards.length > 0 && (
        <Slider {...settings}>
          {cards.map((d) => (
              <div key={d.id} className="px-2"> 
                <div className="bg-white h-[450px] text-black rounded-xl border border-gray-100 shadow-sm overflow-hidden">
                  <div className='h-56 bg-indigo-500 flex justify-center items-center rounded-t-xl'>
                    <img src={d.img} alt="" className="h-44 w-44 rounded-full object-cover" />
                  </div>
                  <div className="flex flex-col items-center gap-4 carousel-cards-text p-4">
                    <div className="fw-bolder tit-cards-home text-center">{d.title}</div>
                    <ReadMoreReadLess
                      className="txt-cards-home"
                      buttonClassName='btn-leer-mas-cards-home'
                      expandLabel={t('buttons.readMore', { defaultValue: 'Leer más' })}
                      collapseLabel={t('buttons.readLess', { defaultValue: 'Leer menos' })}
                      limit="300"
                    >
                      {d.text}
                    </ReadMoreReadLess>
                  </div>
                </div>
              </div>
            ))}
        </Slider>
      )}
    </div>
  );
};

export default EndUserCardCarouselSlider;
